import { createFileRoute } from '@tanstack/react-router';
import LedgerView from '../order/view/ledger/ledger-view';

export const Route = createFileRoute('/orders/$orderGuid/ledger')({ component: LedgerView });
